import { AudienceEnum, GetScopesQuery } from '../../requests/generated';

const districtsOrder = ['IM', 'NL', 'FL', 'SC', 'CA', 'AC', 'SA', 'LE', 'MF'];

const sortGradeListOrder = [
  'PK',
  'KG',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '6A',
  '07',
  '7A',
  '08',
  'A1',
  'GO',
  'A2',
  'I1',
  'I2',
  'I3',
  'AC',
  'SA',
  'P8',
  'PT',
  'ON',
];

const sortSCorderList = [
  '06',
  '6A',
  '07',
  '7A',
  '08',
  'GO',
  'A1',
  'A2',
  'AC',
  'SA',
];

const combineSortGroup = districtsOrder.reduce((acc: string[], district) => {
  const districtGroups = (
    district === 'SC' ? sortSCorderList : sortGradeListOrder
  ).map((grade) => `${district} ${grade}`);

  return [...acc, ...districtGroups];
}, []);

export const prepareScopes = (
  scopes: GetScopesQuery['mnScopes']['collection']
) => {
  if (!scopes) {
    return [];
  }
  const sortedListOption = [...scopes]
    .sort((a, b) => {
      const aIndex = combineSortGroup.findIndex(
        (name) => name === `${a.category} ${a.grade}`
      );
      const bIndex = combineSortGroup.findIndex(
        (name) => name === `${b.category} ${b.grade}`
      );
      return aIndex > bIndex ? 1 : -1;
    })
    .sort((a, b) => {
      const indexA = districtsOrder.indexOf(a.category);
      const indexB = districtsOrder.indexOf(b.category);
      if (indexA === -1 && indexB === -1) {
        return 0;
      }
      if (indexA === -1) {
        return 1;
      }
      if (indexB === -1) {
        return -1;
      }
      return indexA - indexB;
    });

  const arrangeData = sortedListOption.map((scope) => ({
    ...scope,
    displayName: scope.displayName.replace('NL ', ''),
  }));
  return arrangeData;
};

export const getDefaultUserScopeByGradeLevel = (
  gradeLevel: string,
  userState: string,
  scopes: GetScopesQuery['mnScopes']['collection']
) => {
  if (!scopes) {
    return null;
  }

  let gradeLevelKey = '';
  switch (gradeLevel) {
    case 'gl_6':
      gradeLevelKey = '06';
      break;
    case 'gl_7':
      gradeLevelKey = '07';
      break;
    case 'gl_8':
      gradeLevelKey = '08';
      break;
    case 'gl_9':
      gradeLevelKey = 'A1';
      break;
    case 'gl_10':
      gradeLevelKey = 'GO';
      break;
    case 'gl_11':
      gradeLevelKey = 'A2';
      break;
    case 'gl_12':
      gradeLevelKey = 'A2';
      break;
  }

  return scopes.find(
    (scope) =>
      scope.category === userState &&
      scope.grade === gradeLevelKey &&
      scope.contentAudience === AudienceEnum.Student
  );
};
